import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const r = ({
  title: e,
  titleId: o,
  ...c
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M617.248 832.762c13.056 0 23.637 11.733 21.141 24.555-11.456 58.944-63.36 103.445-125.632 103.445-62.293 0-114.176-44.501-125.653-103.445-2.496-12.821 8.085-24.555 21.163-24.555zm262.27-155.168v68.288c0 12.565-10.197 22.784-22.763 22.784H168.627c-12.587 0-22.763-10.219-22.763-22.784v-68.224a64.052 64.052 0 0 1 32.064-55.488l35.456-20.395a22.75 22.75 0 0 0 11.413-19.733V385.711c0-121.877 95.232-224.043 222.891-250.219a1.394 1.394 0 0 0 1.109-1.365v-2.325c0-31.061 20.565-60.096 51.051-65.963 22.315-4.288 42.944 3.413 57.109 17.579 11.52 11.52 18.56 27.307 18.56 44.8v6.827c54.187 10.667 102.827 35.2 140.8 69.12 52.267 46.507 84.48 110.507 84.48 181.547v196.352a22.766 22.766 0 0 0 11.392 19.712l35.328 20.395c19.797 11.435 32 32.576 32 55.424z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), s = i(r);
export {
  s as default
};
